import { render } from "./BulkActions.vue?vue&type=template&id=2ba04336"
import script from "./BulkActions.vue?vue&type=script&lang=js"
export * from "./BulkActions.vue?vue&type=script&lang=js"

import exportComponent from "/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__